import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "information-modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "messageModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-secondary py-2 bg-gradient text-light" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-info-circle fa-fw me-2" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-sm btn-close-white",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.message), 1),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-footer justify-content-center" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-bs-dismiss": "modal"
          }, " Aceptar ")
        ], -1))
      ])
    ])
  ]))
}